import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ScreenOrientationService } from '@monorepo/services';
import { TRESPONSE_AI_ANALYTICS_QUESTION } from '@monorepo/types';
import { MOBILE_SCREEN_UTILS, TTableTreeModel } from '@monorepo/ui';
import { ExcelUtilClass } from '@monorepo/utils';

export type TTableGraphViewModalInputs =
  | { type: 'TABLE'; tableModel: TTableTreeModel; data: TRESPONSE_AI_ANALYTICS_QUESTION }
  | { type: 'CHART'; chartModel: Highcharts.Options };

@Component({
  selector: 'monorepo-table-graph-view-modal',
  templateUrl: './table-graph-view-modal.component.html',
  styleUrls: ['./table-graph-view-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableGraphViewModalComponent implements OnInit, OnDestroy {
  @Input() componentInputs?: TTableGraphViewModalInputs = undefined;
  isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();

  constructor(
    private modalController: ModalController,
    private screenOrientationService: ScreenOrientationService,
    private excelutils: ExcelUtilClass,
  ) {}

  async ngOnInit() {
    await this.screenOrientationService.lockLandscape();
  }

  async ngOnDestroy() {
    await this.screenOrientationService.unlock();
  }

  closeModal() {
    this.modalController.dismiss();
  }

  downloadCsv(headers: string[], data: Partial<Record<string, string | number>>[]) {
    this.excelutils.generateCsvFromData(headers, data, 'ai-analytics-data.csv');
  }
}
